import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const LandOwnerPercentage = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      placeholder="Enter land owner percentage"
      id="ownerPercentage"
      name="ownerPercentage"
      label="Land Owner Percentage"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default LandOwnerPercentage;
